$(function () {
    function sendCallback(element, token) {
        $('#submit').attr('disabled', 'disabled');

        var data = new FormData(element);
        data.append('token', token);

        window.Request.post('/reviews/reviews/send', Object.fromEntries(data), function(response) {
            $(element).find('.input, .textarea').removeClass('is-danger');
            if (response.hasOwnProperty('errors')) {
                var message = [];
                for (var key in response.errors) {
                    $(element).find('#reviewsform-' + key.toLowerCase()).addClass('is-danger');
                    message.push(response.errors[key]);
                }
                window.Modal.show('message', {message: message.join('<br>')});
                $('#submit').removeAttr('disabled');
                return;
            }

            $(element).find('#submit').fadeOut();
            window.Modal.show('message', {message: response.message});
            window.Modal.hide($('#reviews-modal'));
        }, 'json');
    }

    $(document).on('submit', '.reviews-form', function (e) {
        e.preventDefault();
        var element = this;
        getReCaptchaToken(function (token) {
            sendCallback(element, token);
        }, 'reviews')
    });
});